<template lang="pug">
	section.protein-container
		.title-section Calculadora de Proteina
		.content-form
			.subtitle Sexo
			.content-input
				.field
					input.is-checkradio.is-dark#fem-pro(type="radio", v-model="sex", :value="true")
					label(for="fem-pro") Femenino
					input.is-checkradio.is-dark#mas-pro(type="radio", v-model="sex", :value="false")
					label(for="mas-pro") Masculino
			.subtitle Entrenamiento
			.content-input
				.field.mobile-fields
					input.is-checkradio.is-dark#man(type="radio", v-model="entrenamiento", :value="1")
					label(for="man") Mantenimiento
					input.is-checkradio.is-dark#vol(type="radio", v-model="entrenamiento", :value="2")
					label(for="vol") Volumen
					input.is-checkradio.is-dark#def(type="radio", v-model="entrenamiento", :value="3")
					label(for="def") Definición
			.subtitle Peso (kg)
			input(type="number", v-model="w", min="0")
			.results
				.info-result Proteinas diarias recomendadas:
				.ims-result {{ proteinByDay }}
</template>

<script>
import "bulma-checkradio";
export default {
  data() {
    return {
      entrenamiento: 1,
      sex: true,
      w: 70
    };
  },
  computed: {
    proteinByDay() {
      let t = 0;
      switch (this.entrenamiento) {
        case 1:
          if (this.sex) {
            t = 1.8;
          } else {
            t = 2.2;
          }
          break;
        case 2:
          if (this.sex) {
            t = 1.6;
          } else {
            t = 2;
          }
          break;
        case 3:
          if (this.sex) {
            t = 2;
          } else {
            t = 2.7;
          }
          break;
      }
      return (t * this.w).toFixed(0);
    }
  }
};
</script>
